import PropTypes from "prop-types";
import React from "react";
/**
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {any} props.className
 * @returns {JSX.Element}
 */

export const InfoPill = ({
  title,
  className
}) => /*#__PURE__*/React.createElement("div", {
  className: `flex items-center justify-center rounded bg-en-gray-100 py-1 px-2 m-1 ${className ? className : ""}`
}, title);
InfoPill.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string
};